import { INTRACTION_LOGO_BIG_WIDTH } from '../libs/HardCodedSizes'
import { Images } from '../../../pure-js/libs/Images'
import FigmaImageContainer from './FigmaImageContainer'

export function SignInLandingIntractionLogo() {
  return <FigmaImageContainer imageKey={Images.pngLogo} width={INTRACTION_LOGO_BIG_WIDTH} />
}
